import React from "react";

const Legend = ({content, inView, reference}) => {

  return (
    <div ref={reference} className="legend w-full relative mb-4 font-corps-med font-medium">
     { 
     inView ?
    <span className={`${inView ? 'animate' : ''} texte opacity-0 tracking-wider orange relative h-6`}>
      <span className={`${inView ? 'animate' : ''} the-block absolute flex top-0 text-sm`}> </span>
      {content}
    </span>
    : ''
    }
  </div>
  )
}


export default Legend
